// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d13d6e1d","667":"d54384d4"}[chunkId] + ".chunk.js";
};